export const data = [
  {
    title: "Free Plan",
    description:
      "Build and test using our core set of products with up to 100 API requests",
    price: "0.00",
    features: [
      { icon: true, featureName: "Transactions" },
      { icon: true, featureName: "Auth" },
      { icon: true, featureName: "Identity" },
      { icon: false, featureName: "Investments" },
      { icon: false, featureName: "Assets" },
      { icon: false, featureName: "Liabilities" },
      { icon: false, featureName: "Income" },
    ],
  },
  {
    title: "Basic Plan",
    description:
      "Launch your project with unlimited requests and no contractual minimums",
    price: "249.00",
    features: [
      { icon: true, featureName: "Transactions" },
      { icon: true, featureName: "Auth" },
      { icon: true, featureName: "Identity" },
      { icon: true, featureName: "Investments" },
      { icon: true, featureName: "Assets" },
      { icon: false, featureName: "Liabilities" },
      { icon: false, featureName: "Income" },
    ],
  },
  {
    title: "Premium Plan",
    description:
      "Get tailored solutions, volume pricing, and dedicated support for your team",
    price: "499.00",
    features: [
      { icon: true, featureName: "Transactions" },
      { icon: true, featureName: "Auth" },
      { icon: true, featureName: "Identity" },
      { icon: true, featureName: "Investments" },
      { icon: true, featureName: "Assets" },
      { icon: true, featureName: "Liabilities" },
      { icon: true, featureName: "Income" },
    ],
  },
];
